export function debounce<TArgs extends unknown[]>(fn: (...args: TArgs) => unknown, delay: number) {
	let timeout: ReturnType<typeof setTimeout>;

	return function (...args: TArgs) {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn(...args), delay);
	};
}
